import styled from 'styled-components'
import { NavLink } from 'react-router'

export const RFWrap = styled.div`
   display: grid;
   grid-template-columns: 220px 1fr;
   gap: 28px;
`

export const RFLeft = styled.div`
   display: flex;
   flex-direction: column;
   gap: 14px;
   margin-top: 5px;
`

export const RFNav = styled.div`
   display: flex;
   flex-direction: column;
   gap: 6px;
`

export const RFNavItem = styled(NavLink)`
   display: inline-flex;
   align-items: center;
   justify-content: flex-start;
   width: 100%;
   height: 34px;
   padding: 0 10px;
   border-radius: 6px;
   background: transparent;
   color: #858589;
   font-size: 13px;
   font-weight: 500;
   text-align: left;
   cursor: pointer;
   border: 1px solid transparent;
   text-decoration: none;
   transition: background .15s ease;

   &:hover { background: #F9F9FA; }
   &.active {
      background: #F5F5F6;
      color: #101018;
   }

   .meta {
      color: #B3B3B6;
      font-size: 10px;
      letter-spacing: -0.02em;
      margin-left: 8px;
   }

   .pill {
      font-size: 10px;
      color: #6D6D72;
      background: #FFF;
      border-radius: 5px;
      padding: 2px 5px;
      margin-left: 8px;
      font-family: 'Geist Mono', 'Geist', monospace;
      font-weight: 500;
      border: 0.5px solid #EDEDEE;
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.04);
   }
`

export const RFMain = styled.div`
   display: flex;
   flex-direction: column;
`

export const RFTitle = styled.h2`
   color: #101018;
   font-size: 16px;
   font-weight: 600;
   margin: 2px 0 8px;
`

export const RFDesc = styled.p`
   color: #6D6D72;
   font-size: 13px;
   line-height: 1.5;
   margin: 0 0 18px;
`
